// API Configuration
import { API_BASE_URL as RUNTIME_API_BASE_URL } from './runtimeEnv'
export const API_BASE_URL = RUNTIME_API_BASE_URL

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/admin/staff/login',
    OWNER_LOGIN: '/admin/login-owner',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',

    STAFF_UPDATE_PASSWORD: '/admin/staff-update-password',
    OWNER_UPDATE_PASSWORD: '/admin/owner/update-password',
    ACCEPT_RULES_OWNER: '/admin/accept-rules',
    ACCEPT_RULES_STAFF: '/admin/staff/accept-rules',
    UPDATE_PLATFORM_CONFIG: '/admin/update-platform-configurations',
    
    // 2FA Endpoints
    VERIFY_2FA_STAFF: '/admin/staff/verify-2fa',
    VERIFY_2FA_OWNER: '/admin/owner/verify-2fa',
    GENERATE_2FA_LINK: '/2fa/telegram/generate-link-code',
    VERIFY_PASSWORD: '/2fa/telegram/verify-password',
    SEND_DISABLE_2FA_CODE: '/2fa/telegram/send-disable-code',
    DISABLE_2FA: '/2fa/telegram/disable-2fa',

    // 'Secure Auth Verification App' (Android, offline TOTP). Same shared
    // controller as the telegram routes above — it resolves OWNER / STAFF from
    // the token, so the player-side path serves the admin panel too.
    ANDROID_PAIR: '/2fa/android/pair',
    ANDROID_ENABLE: '/2fa/android/enable',
    ANDROID_DISABLE: '/2fa/android/disable',

    // Google Authenticator for the operator's OWN login (owner / staff).
    // server/routes/admin/secureAuthSelfRoutes.js → adminGoogleAuthController.
    GOOGLE_SETUP: '/admin/secure-auth/google/setup',
    GOOGLE_ENABLE: '/admin/secure-auth/google/enable',
    GOOGLE_DISABLE: '/admin/secure-auth/google/disable',
  },
  USER: {
    PROFILE: '/admin/staff/profile',
    // Legacy owner profile — full Owner row + flat wallet merge (DownOb,
    // cash_received, platform_configurations, telegram2FAEnabled...). Settings
    // pages still read those keys, so this stays.
    OWNER_PROFILE: '/admin/profile',
    // Session profile for a logged-in OWNER — same contract as the staff one
    // ({ data: { user } }, curated wallet/points keys). Login, 2FA, app-init
    // and the post-money-move refresh all go through this.
    OWNER_PROFILE_V2: '/admin/owner/profile',
    ALL_DETAILS: '/admin/users/all-details',
    CREATE_USER: '/admin/users/create-under-parent',
    CREATE_STAFF: '/admin/staff/create-staff',
    CHECK_USERNAME: '/admin/check-username',
    UPDATE_STATUS_PASSWORD: '/admin/staff-user-update',
  },
  D99: {
    NET_EXPOSURE: '/d99/net-exposure',
    // Total Bets page (owner): type=current|past, category=sport, page, limit, search
    BET_LIST: '/d99/bet-list',
  },
  // Wallet — Account List ke Action buttons (D / W / C).
  // Sabhi routes verifyTransactionPassword ke peeche hain, so har payload me
  // transactionPassword bhejna zaroori hai.
  WALLET: {
    DEPOSIT_ADD: '/admin/wallet/deposit/add',   // D → parent se direct child ko points
    WITHDRAW: '/admin/wallet/withdraw',         // W → deposit ka ulta (remark required)
    POINTS_SETTLE: '/admin/wallet/points/settle', // S → direct child ka pending settle
    SET_CREDIT_LIMIT: '/admin/wallet/set-credit-limit', // C → direct child ke wallet me cr set
    OWNER_SELF_DEPOSIT: '/admin/wallet/owner/self-deposit', // Owner khud ke wallet me balance add kare (owner only)
  },
  REPORTS: {
    CURRENT_BETS: '/admin/reports/current-bets',
    MARKET_ANALYSIS: '/admin/reports/market-analysis',
    TOTAL_PROFIT_LOSS: '/admin/reports/total-profit-loss',
    USER_BET_HISTORY: '/admin/reports/user-bet-history',
    USER_REGISTER_DETAIL: '/admin/reports/user-register-detail',
  },
  TABLE_CASINO: {
    LIST: '/admin/table-casino/list',
    LOCKS: '/admin/table-casino/locks',
    LOCK: '/admin/table-casino/lock',
  },
  BETLOCK: {
    MARKET_LOCK_CHILDREN: '/admin/betlock/market-locks', // GET /:event_id?market_id=xxx&market_name=xxx
    TOGGLE_MARKET_LOCK: '/admin/betlock/toggle-market-lock',
    BULK_TOGGLE_MARKET_LOCK: '/admin/betlock/bulk-toggle-market-lock',
  },
  SPORTS_DATA: '/user/cricket/all-data',
  GET_SPORTS_TREE: '/user/all/sports/tree',
  GET_SPORT_DATA: '/user/cricket/all-data',
  GET_MATCH_PRIVATE_DATA: '/user/cricket/get-match-private-data',
  GET_SPORTS_SCORE_CARD: '/user/cricket/score-card',
  // Buffer Time — owner-only. Server: routes/admin/bettingConfigRoutes.js
  // (mounted at /api/admin), controller enforces max 60s.
  BETTING_CONFIG: {
    BUFFER_SPORTS: '/admin/betting-config/buffer/sports',
    BUFFER_SPORTS_BULK: '/admin/betting-config/buffer/sports/bulk',
    BUFFER_CASINO: '/admin/betting-config/buffer/casino',
  },
  // Commission — owner-only. Sports win commission per sport x league x market.
  // Server: routes/admin/commissionConfigRoutes.js (mounted at /api/admin).
  // Auto Void — owner-only. Server: routes/admin/bettingConfigRoutes.js.
  AUTO_VOID: {
    CONFIG: '/admin/betting-config/auto-void',
    PENDING: '/admin/betting-config/auto-void/pending',
    LINKS: '/admin/betting-config/result-links',
  },
  COMMISSION_CONFIG: {
    SPORTS: '/admin/commission-config/sports',
    SPORTS_BULK: '/admin/commission-config/sports/bulk',
  },
  INTERNALSETTLE: {
    MOMATCHES: '/internalsettle/momatches',
    FANMATCHES: '/internalsettle/fanmatches',
    DECLARERESULT: '/internalsettle/declareresult',
    VOID: '/internalsettle/void',
    OPEN_BETS: '/internalsettle/open-bets',
    VOID_SINGLE_BET: '/internalsettle/void-single-bet',
    SETTLED_MARKETS: '/internalsettle/settled-markets',
    SETTLED_BETS: '/internalsettle/settled-bets',
    VOID_MARKET_AFTER_SETTLEMENT: '/internalsettle/void-market-after-settlement',
    VOID_BET_AFTER_SETTLEMENT: '/internalsettle/void-bet-after-settlement',
    // Delete Bet — void jaisa paisa wapas, phir bet + uska poora statement trail delete
    DELETE_BET: '/internalsettle/delete-bet',
    // Casino delete (owner only) — void + bet/ledger/point rows purge. { bet_id }
    DELETE_CASINO_BET: '/internalsettle/delete-casino-bet',
    // Void audit — Total Bets page isse pata karta hai ki kaunsi settled bet pehle se void/deleted hai
    VOID_AUDIT: '/internalsettle/void-audit',
    // Casino — unsettled (stuck) bets aur unka void
    CASINO_OPEN_BETS: '/internalsettle/casino-open-bets',
    VOID_CASINO_BETS: '/internalsettle/void-casino-bets',
    CASINO_SETTLED_BETS: '/internalsettle/casino-settled-bets',
    VOID_SETTLED_CASINO_BET: '/internalsettle/void-settled-casino-bet',
  },
  // Executive (multi-login) accounts — server mounts these at /api/executive
  MULTI_LOGIN: {
    LOGIN: '/executive/login',
    CREATE: '/executive/create',
    LIST: '/executive/list',
    BASE: '/executive', // + /:id (PUT), /:id/active, /:id/password, /:id (DELETE)
  },
}
